import styled from "styled-components";

export const EmptyStateContent = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    flex-direction: column;
    text-align: center;
    cursor: pointer;
`;
